import { type ReactNode } from "react";
import { Outlet } from "react-router-dom";

import { Footer } from "@/marketing/layout/footer";
import { Navbar } from "@/marketing/layout/navbar";
import { ScrollToTop } from "@/marketing/scroll-to-top";

export default function MarketingLayout({ children }: { children?: ReactNode }) {
  return (
    <div className="marketing-theme flex min-h-screen flex-col bg-background text-foreground">
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-20">
        {children ?? <Outlet />}
      </main>
      <Footer />
    </div>
  );
}
